const COLOR = {
  grey: "#f5f5f5",  
  borderGrey: "#ebebeb"  
};

export default {
  COLOR
};